import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useOfferTags } from 'cityads-v3/hooks/offers'
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material/styles'
import darkTheme from 'cityads-v3/utils/muiTheme/darkTheme'
import { useOfferFiltersContext } from '../../OfferFilters.hooks'
import classes from './BlackFridayBanner.scss'

import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'

export const BLACK_FRIDAY_TAG = `black_friday`

const buttonTheme = createTheme({
  palette: {
    mode: 'dark',

    primary: {
      main: 'rgba(228, 52, 21, 1)',
      contrastText: '#FFD0B4',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          color: '#FFD0B4',
          border: '2px solid #2D0C08',
        },
      }
    },
  },
})

export default function BlackFridayBanner(): JSX.Element {
  const { t } = useTranslation(['main'])
  const [, tagsByCode] = useOfferTags()
  const offerFilters = useOfferFiltersContext()

  const handleSelectTag = useCallback(() => {
    if (offerFilters.selectedFilters.fields.tags.value.includes(BLACK_FRIDAY_TAG)) {
      offerFilters.refresh()
    } else {
      offerFilters.selectedFilters.fields.tags.pushToArray(BLACK_FRIDAY_TAG)
      offerFilters.selectedFilters.handleSubmit()
    }
  }, [offerFilters])

  if (!tagsByCode?.[BLACK_FRIDAY_TAG]?.is_available_in_filter) {
    return null
  }

  return (
    <MuiThemeProvider theme={darkTheme}>
      <div className={classes.container}>
        <div className={classes.banner}>
          <div className={classes.text}>
            <Typography
              color="textPrimary"
              variant="h6"
              className={classes.title}
            >{t('blackFriday.title')}</Typography>
            <Typography color="textSecondary" className={classes.description}>{t('blackFriday.description')}</Typography>

            <MuiThemeProvider theme={buttonTheme}>
              <Button
                disableElevation
                color="primary"
                classes={{ root: classes.button }}
                onClick={handleSelectTag}
                variant="contained"
              >{t('blackFriday.button')}</Button>
            </MuiThemeProvider>
          </div>
        </div>
      </div>
    </MuiThemeProvider>
  )
}
